import fetch from 'isomorphic-fetch'
/**
 * Implements a data fetcher using Axios - replace with your favorite
 * SSR-capable HTTP or fetch library if you like. See HttpJsonFetcher<T> type
 * in sitecore-jss library for implementation details/notes.
 * @param {string} url The URL to request; may include query string
 * @param {any} data Optional data to POST with the request.
 */

export const dataFetcher = async <T>(
  url: URL | RequestInfo,
  body?: BodyInit
): Promise<{ status: number; data?: T; response?: Response }> => {
  const response = await fetch(url, {
    method: body ? 'POST' : 'GET',
    body,
    headers: {
      Accept: 'application/vnd.christies.v1+json',
    },
    // note: fetch needs to use `credentials: 'include` in order for Sitecore cookies to be included in CORS requests
    credentials: 'include',
  })

  if (response && response.ok) {
    const data = await response.json()
    const formatedResponse = { data, status: response.status }
    return formatedResponse
  }
  return { status: response.status }
}
